import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { cancelNegativation } from "@/common/services/renter-negativation.api";
import { Modal } from "flowbite-react";
import FormCancelNegativation from "./form/FormCancelNegativation";

type Props = {
  onClose: () => void;
  negativationId: string;
}

export default function ModalCancelNegativation({ onClose, negativationId }: Props) {

  const { notifySuccess, notifyError } = useToastContext();

  async function handleCancelNegativation(data: { reason: string }) {
    try {
      // Usar negativationId do props e reason do data
      const result = await cancelNegativation(negativationId, data.reason);
      if (result.ok) {
        notifySuccess("Negativação cancelada com sucesso.");
        onClose();
      } else {
        notifyError(result.message || "Erro ao cancelar negativação.");
      }
    } catch (error) {
      console.error("Erro ao cancelar negativação:", error);
      notifyError("Erro inesperado ao cancelar negativação.");
    }
  }

  return (
    <div>
      <Modal
        show={true}
        onClose={onClose}
        className="dark:text-black dark:bg-none"
      >
        <Modal.Header>
          <h2 className="dark:text-black">Cancelar Negativação</h2>
        </Modal.Header>
        <Modal.Body>
          <FormCancelNegativation
            onSubmit={handleCancelNegativation}
            onClose={onClose}
            negativationId={negativationId}
          />
        </Modal.Body>


      </Modal>
    </div>
  );
}